import styled from 'styled-components';

export const Container = styled.div`
  .items-header {
    width: 100%;
    border: 0;
    background: ${(props) => props.theme.$gray200};
    text-align: left;
    color: ${(props) => props.theme.$dark_slate_blue};
  }

  .items-search {
    width: 100%;
    max-width: 320px;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 6px;
    padding-right: 8px;
  }

  .items-search .form-control {
    border: 0;
    box-shadow: none;
  }

  .items-table {
    table-layout: fixed;
    min-width: 720px;
  }

  .items-table .item-cell {
    width: 64px;
  }

  .items-table .desc-cell {
    width: 38%;
    word-break: break-word;
  }

  .items-table .qnt-cell {
    width: 100px;
  }

  .items-table th {
    background: ${(props) => props.theme.$gray100};
    color: ${(props) => props.theme.$dark_slate_blue};
    border-top: 0;
    font-weight: bold;
  }

  .items-table td {
    color: ${(props) => props.theme.$dark_slate_blue};
    vertical-align: middle;
  }
`;
